import axios from "axios";
import { SIGN_IN_API } from "../constants/apiEndpoints";

export const getToken = () => {
  return localStorage.getItem("token");
};

export const doSignIn = async (value) => {
  return axios.post(SIGN_IN_API, value);
};

export const headers = () => {
  return {
    headers: { authorization: `Bearer ${localStorage.getItem("token")}` },
  };
};

export const reducer = (state, action) => {
  const { type, payload } = action;
  return { ...state, [type]: payload };
};
